module.exports = __webpack_public_path__ + "img/engravingRingsize-1.bb9e31b.webp";